"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefreshAndSessionExpirationDate = exports.getAccessTokenExpirationDate = exports.validateToken = exports.tokenExchange = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const constant_1 = require("../constant");
/**
 * This function exchanges the auth code to get the auth token
 */
const tokenExchange = async (authDomain, requestBody) => {
    const tokenUrl = `${authDomain}/api/tokens`;
    const response = await fetch(tokenUrl, {
        method: "POST",
        body: JSON.stringify(requestBody),
        credentials: "include",
    });
    if (!response.ok) {
        if (requestBody.grantType === "authorization_code") {
            throw new Error(constant_1.ERROR_MESSAGE.TOKEN_EXCHANGE_FAIL);
        }
        else {
            throw new Error(constant_1.ERROR_MESSAGE.TOKEN_REFRESH_FAIL);
        }
    }
    return await response.json();
};
exports.tokenExchange = tokenExchange;
const validateToken = (token) => {
    try {
        if (token) {
            const decodedToken = (0, jwt_decode_1.default)(token);
            return !!decodedToken.exp && decodedToken.exp > Date.now() / 1000;
        }
    }
    catch {
        return false;
    }
    return false;
};
exports.validateToken = validateToken;
function getAccessTokenExpirationDate(expiresIn) {
    const date = new Date(Date.now() + expiresIn * 1000);
    return date;
}
exports.getAccessTokenExpirationDate = getAccessTokenExpirationDate;
function getRefreshAndSessionExpirationDate(expiresIn) {
    const effectiveExpiresIn = expiresIn === 600 ? expiresIn : 2592000;
    return new Date(Date.now() + effectiveExpiresIn * 1000);
}
exports.getRefreshAndSessionExpirationDate = getRefreshAndSessionExpirationDate;
